const angles = { right: 0, down: 90, left: 180, 'up-right': -45 } as const

/** Draw arrows explicitly so platform emoji fonts cannot change their appearance. */
export function ArrowIcon({ direction = 'up-right' }: { direction?: keyof typeof angles }) {
  return (
    <svg className="arrow-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <path d="M3 8h10M8 3l5 5-5 5" transform={`rotate(${angles[direction]} 8 8)`} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
